import detectVideoSupplier from './detectVideoSupplier';
const $ = jQuery.noConflict();

const lightboxControlVideo = {
    bindEvent() {
        $('.js-lightbox-video').on('click', '.video-button', this.togglePlay);
    },

    togglePlay() {
        const wrapper = $(this).closest('.video-button-container');
        const video = wrapper.find('iframe');
        const src = $(this).attr('data-ajax-lightbox-video');
        if (!wrapper.hasClass('video-play')) {
            lightboxControlVideo.play(wrapper, video, src);
        }
    },

    play(wrapper, video, src) {
        wrapper.addClass('video-play');
        video.attr('allow', 'autoplay');
        if (detectVideoSupplier.isYT(src) || detectVideoSupplier.isVimeo(src)) {
            video[0].src = `${src}&autoplay=1`;
        } else if (detectVideoSupplier.isWistia(src)) {
            let replaceSrc = src.substring(0, src.indexOf('?'));
            replaceSrc = `${replaceSrc}?autoPlay=true`;
            video[0].src = replaceSrc;
        }
    },

    stop(video) {
        const wrapper = video.closest('.video-button-container');

        if (wrapper.hasClass('video-play')) {
            wrapper.removeClass('video-play');
            video.attr('allow');
            video[0].src = '';
        }
    },
};

export default lightboxControlVideo;
